import {upload_path} from "../../_AE/Helpers";

export const ROUTE = {
  prefix: "/meats"
}
export const context_title = {
  singular: "Meat",
  plural: "Meats",
}
export const images_path = upload_path+"/meats"


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    enabled: "",
    premium: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultEntity = {
  "id": undefined,
  "calories": 0,
  "title_fr": "",
  "title_en": "",
  "title_ar": "",
  "notice_fr": "",
  "notice_en": "",
  "notice_ar": "",
  "category": undefined,
  "nutritions": [],
  "ingredients": [],
  "instructions": [],
  "enabled": true,
  "premium": false
};